import { render, staticRenderFns } from "./UserTypeSwitch.vue?vue&type=template&id=4d078cb6&scoped=true&"
import script from "./UserTypeSwitch.vue?vue&type=script&lang=js&"
export * from "./UserTypeSwitch.vue?vue&type=script&lang=js&"
import style0 from "./UserTypeSwitch.vue?vue&type=style&index=0&id=4d078cb6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d078cb6",
  null
  
)

export default component.exports